__turbopack_context__.v({
  "alert": "alert-component-module-scss-module__v_wFTq__alert",
  "alert--align-center": "alert-component-module-scss-module__v_wFTq__alert--align-center",
  "alert--borderless": "alert-component-module-scss-module__v_wFTq__alert--borderless",
  "alert--error": "alert-component-module-scss-module__v_wFTq__alert--error",
  "alert--info": "alert-component-module-scss-module__v_wFTq__alert--info",
  "alert--success": "alert-component-module-scss-module__v_wFTq__alert--success",
  "alert--warning": "alert-component-module-scss-module__v_wFTq__alert--warning",
  "alert__close": "alert-component-module-scss-module__v_wFTq__alert__close",
  "alert__content": "alert-component-module-scss-module__v_wFTq__alert__content",
  "alert__icon": "alert-component-module-scss-module__v_wFTq__alert__icon",
});
